<template>
    <VJoyPanel>
        <template #panel-title><h2>Refresh answering statistics</h2></template>
        <template #panel-body>
            <VJoyButton :loading="isLoading" @click="refresh">Recompute</VJoyButton>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {ref} from '#imports';
    import {pushVJoySnackbar, VJoyButton, VJoyPanel} from '@maltjoy/core-vue';
    import {Configuration, DevToolsApi} from '@api';
    import {useProfileStore} from '~/store/profileStore';

    const isLoading = ref(false);
    const {profile} = storeToRefs(useProfileStore());

    async function refresh() {
        isLoading.value = true;
        try {
            await new DevToolsApi(new Configuration({basePath: ''})).computeStatistics({profileId: profile.value!.profileId});
            pushVJoySnackbar({
                props: {
                    message: 'Statistics refreshed successfully',
                    level: 'success',
                },
            });
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: 'Error: statistics not recomputed',
                    level: 'error',
                },
            });
        } finally {
            isLoading.value = false;
        }
    }
</script>
